import { render, staticRenderFns } from "./SchoolBased.vue?vue&type=template&id=accc4dd0&scoped=true&"
import script from "./SchoolBased.vue?vue&type=script&lang=js&"
export * from "./SchoolBased.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBased.vue?vue&type=style&index=0&id=accc4dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc4dd0",
  null
  
)

export default component.exports